import { generateUUID } from "../utils/utils";

export class SaveView {
    public file_uuid: string;
    constructor(public file_name: string, public file_content: string, public hierarchy?: string, public model_UUID?: string){
        this.file_uuid = generateUUID();
    }
}